import { featuresItems } from '@/mocks/homeData';

const iconBgMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-600',
};

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            为什么百万用户选择52吃瓜网
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresItems.map((item, i) => (
            <div key={i} className="text-center p-6 bg-background-100 rounded-xl">
              <div className={`w-12 h-12 mx-auto mb-4 rounded-xl flex items-center justify-center ${iconBgMap[item.color]}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}